export class TransportTimeLineSortOrder {
    id: number = -1;
  
    unitName: string = '';
    vehicleId: number = -1;
    driverId: number = -1;
    subcontractorId: number = -1;
    sortOrder: number = -1;
  
    createdAt: string = '';
    updatedAt: string = '';
  
  }